// extracted by mini-css-extract-plugin
module.exports = {"newCardClose":"CreditCard_newCardClose__38VNb","closing_animation":"CreditCard_closing_animation__2S-m9"};